import { ENUM_CUS_EVENT, ENUM_TOAST_TYPE } from "../../../components/common/consts";
import { setLoadingBroadcaster } from "../../../store/chatSlice";
import { setLastFrame } from "../../../store/commonSlice";
import { dispatchCusEvent, getPositionParam } from "../../../utils/utils";

class JanusUtils {
  // контекст канваса последнего слайда
  #lastFrameRef;
  // задний елемент канваса, с блюром
  #canvasRef;

  dispatch;

  static #instance = null;

  constructor({ dispatch, canvasRef, lastFrameRef }) {
    if (JanusUtils.#instance) {
      console.log("already instance");
      return JanusUtils.#instance;
    }

    JanusUtils.#instance = this;
    this.tmByMessage = {};

    this.dispatch = dispatch;
    this.#canvasRef = canvasRef;
    this.#lastFrameRef = lastFrameRef;
  }

  get lastFrameRef() {
    return this.#lastFrameRef;
  }

  #toast(mes, type, tm) {
    if (this.tmByMessage[mes]) return;

    dispatchCusEvent(ENUM_CUS_EVENT.translationToast, { message: mes, type });
    this.tmByMessage[mes] = true;
    setTimeout(() => (this.tmByMessage[mes] = false), tm);
  }

  successToast(mes, tm) {
    this.#toast(mes, ENUM_TOAST_TYPE.success, tm);
  }

  infoToast(mes, tm) {
    this.#toast(mes, ENUM_TOAST_TYPE.info, tm);
  }

  errorToast(mes, tm = 0) {
    this.#toast(mes, ENUM_TOAST_TYPE.error, tm);
  }

  setLastFrameByVideo(video) {
    const canvas = this.lastFrameRef.current;
    const hasValidVideoFrame =
      video && video.readyState >= 2 && video.videoWidth > 0 && video.videoHeight > 0;

    console.log(
      "hasValidVideoFrame",
      hasValidVideoFrame,
      video.readyState,
      video.videoWidth,
      video.videoHeight
    );

    if (canvas && hasValidVideoFrame) {
      console.log("canvas", canvas);

      const ctx = canvas.getContext("2d");
      const { x, y, width, height } = getPositionParam(canvas, video);

      ctx.drawImage(video, x, y, width, height);
      const frameAsImage = canvas.toDataURL("image/png");
      this.dispatch(setLastFrame(frameAsImage));
      console.log("setLoadingBroadcaster true");
      this.dispatch(setLoadingBroadcaster(true));
    } else {
      console.log("no canvas");
    }
  }
}

export default JanusUtils;
